// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modalHead[data-v-92804b02] {\n  color: #000;\n  font-size: 20px;\n  text-align: left;\n}\n.modalContent[data-v-92804b02] {\n  text-align: left;\n  font-size: 14px;\n}\n.control-input[data-v-92804b02] {\n  margin: 20px 0;\n  width: 200px;\n}\n.control-input span[data-v-92804b02] {\n  display: block;\n  float: left;\n}\n.all[data-v-92804b02] {\n  width: 200px;\n  height: 76px;\n  line-height: 76px;\n  cursor: pointer;\n  color: #1fa0e8;\n}", ""]);
// Exports
module.exports = exports;
